/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {NavLink} from "react-router-dom";


import BottomBarMenuItemType from "@UIParts/BarBottom/_Interfaces/MenuElement";


export const BottomBarElementComponent: React.FC<BottomBarMenuItemType> = ({
    location,
    menuElementURL, menuElementText, menuElementTitle,
    menuElementIcon, menuElementActiveIcon, menuElementCssClass,
    menuElementExactStatus = false
}): JSX.Element | null => {


    const elementActiveStatus =
        !menuElementExactStatus ? location.pathname.includes(menuElementURL) : location.pathname === menuElementURL
    ;


    return (
        <li className={"bottom-menu-bar-element"}>

            <NavLink
                to={menuElementURL}
                exact={menuElementExactStatus}
                title={menuElementTitle}
                className={"bottom-menu-bar-link" + (menuElementCssClass ? " " + menuElementCssClass : "")}

            >
                <img src={elementActiveStatus ? menuElementActiveIcon : menuElementIcon} alt={menuElementTitle} />
                <span>{menuElementText}</span>
            </NavLink>

        </li>
    );

};


export default BottomBarElementComponent;
